import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import moment from 'moment';
import 'moment/locale/de'
import { orderBy } from '../common/orderby';

class ScheduleSelector extends Component {
    static propTypes = {
        actions: PropTypes.object.isRequired,
        scheduleKey: PropTypes.string.isRequired
    };

    handleChange(event, sp) {
      
        this.props.actions.setSelectedSchedule(this.props.scheduleKey, event.target.value === "none" ? undefined: event.target.value);
    }

    render() {
        console.log({blacklist: this.props.blacklisted, all: Object.keys(this.props.schedules), filtered: Object.keys(this.props.schedules).filter(sId => this.props.schedules[sId].seasonId == this.props.currentSeasonId)});
        return <div style={{ display:"inline-block"}}>
         <Select
          value={(this.props.selectedSchedules && this.props.selectedSchedules[this.props.scheduleKey]) || "none"}
          onChange={this.handleChange.bind(this)}
          inputProps={{
            name: this.props.scheduleKey,
            id: this.props.scheduleKey,
          }}
        >
            {orderBy(Object.values(this.props.schedules).filter(schedule => schedule.seasonId == this.props.currentSeasonId
            && (!this.props.blacklisted || !this.props.blacklisted.some(b => schedule.id == b))
            ), s => s.creation).map(schedule => 
            <MenuItem value={schedule.id}>{moment(schedule.creation).format("DD.MM.YYYY HH:mm")} - K: {schedule.totalCost} {schedule.description !== "initialized" ? " - " + schedule.description : ""} </MenuItem>)}
            {this.props.emptyLabel && 
            <MenuItem value={"none"}>{this.props.emptyLabel}</MenuItem>
            }
        </Select>
        </div>;
    }


}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
      schedules: state.home.schedules,
      selectedSchedules: state.home.selectedSchedules,
      currentSeasonId: state.home.currentSeasonId,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleSelector);



// WEBPACK FOOTER //
// ./src/features/home/ScheduleSelector.js